import React, { useState } from "react";

export default function CustomDateRange({ onChange }) {
  const today = new Date().toISOString().split("T")[0];
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const handleStartChange = (e) => {
    const value = e.target.value;
  
    if (value <= today) {
      setStartDate(value);

      if (endDate && value > endDate) {
        setEndDate(today);
        onChange?.([value, today]);
      } else {
        onChange?.([value, endDate]);
      }
    }

   
  };

  const handleEndChange = (e) => {
    const value = e.target.value;

    if (value >= startDate && value <= today) {
      setEndDate(value);
      onChange?.([startDate, value]);
    }
  };

  const handleClear = () => {
    setStartDate("");
    setEndDate("");
    onChange?.(["", "" ,"clear"]);
  };

  const inputStyle = {
    border: "1px solid var(--admin-page--color)",
    borderRadius: "5px",
    padding: "5px 10px",
    marginRight: "10px",
    cursor: "pointer",
  };

  const buttonStyle = {
    border: "1px solid var(--admin-page--color)",
    borderRadius: "5px",
    padding: "5px 10px",
    backgroundColor: "#fff",
    color: "var(--admin-page--color)",
    cursor: "pointer",
    height: "36px",
  };

  return (
    <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
      <label>
        Start Date:{" "}
        <input
          type="date"
          value={startDate}
          max={today}
          onChange={handleStartChange}
          style={inputStyle}
        />
      </label>

      <label>
        End Date:{" "}
        <input
          type="date"
          value={endDate}
          min={startDate || undefined}
          max={today}
          disabled={!startDate}
          onChange={handleEndChange}
          style={{
            ...inputStyle,
            cursor: startDate ? "pointer" : "not-allowed",
          }}
        />
      </label>

      <button onClick={handleClear} style={buttonStyle}>
        Clear
      </button>
    </div>
  );
}
